<template>
	<div>
		<pdf
			v-for="i in numPages"
			:key="i"
			:src="src"
			:page="i"
			
		></pdf>
	</div>
</template>

<script>

import pdf from 'vue-pdf'

export default {
    props: ["src"],
	components: {
		pdf
	},
	data() {
		return {
			pdf: null,
			numPages: undefined,
		}
	},
	mounted() {
        if (this.src != null) {
            this.pdf = pdf.createLoadingTask(this.src);
            this.pdf.promise.then(pdf => {

                this.numPages = pdf.numPages;
            });
        }
	}
}

</script>